import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <a
        target="_blank"
        className="footer-link"
        href="https://github.com/webdevrachit"
        rel="noreferrer"
      >
        Say Hi.!
      </a>
    </div>
  );
};

export default Footer;
